// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__2DgvD","card":"Wrapper_card__1e6O8","loaderBlock":"Wrapper_loaderBlock__2_Ufb","noData":"Wrapper_noData__2cirG","sourceList":"Wrapper_sourceList__3FHRR"};